import hasRightForEndpoint from "modules/roles/helpers/hasRightForEndpoint";
import { useSelfcare } from "modules/selfcare/hooks/useSelfcare";
import { ENDPOINTS } from "modules/shared/webservices/constants/endpoints";

export function useHasRightForBackToDraft() {
  const { data } = useSelfcare(false);
  return hasRightForEndpoint(ENDPOINTS.BACK_TO_DRAFT, ["POST"], data?.routes);
}
